/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "lsLambdaNotifyUserOfEventApi",
            "endpoint": "https://j2292554q8.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        },
        {
            "name": "lsLambdaPublicQueryApi",
            "endpoint": "https://h6orb8puhl.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        },
        {
            "name": "lsManageUserApi",
            "endpoint": "https://v8gv904q3d.execute-api.eu-west-2.amazonaws.com/master",
            "region": "eu-west-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://g2mxpxfnpfahxgbatjp6bq4434.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-ac4sad6eorbq7gfjtd3dcsf7tu",
    "aws_cognito_identity_pool_id": "eu-west-2:b8a0b7a1-680a-4e1f-bb46-98c3664e251d",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_GqjPnvpJV",
    "aws_user_pools_web_client_id": "7nfdnl4pub3vt6c7o7c87r0qha",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME",
        "PHONE_NUMBER"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "lseventsapp5f68957d0a844bfbb879ea917f5c1f7c124856-master",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
